import styled from 'styled-components';
import {WidgetFooterPhraseFirst} from 'components/WidgetFooter/WidgetFooterPhraseFirst';

export const WidgetFooterPhraseSecond = styled(WidgetFooterPhraseFirst)`
  animation-delay: 3s;
`;
